import React, { useState } from "react";

const HeavyRefreshButton = ({row,handleHardReset}) => {
    const [hardReset, setHardReset] = useState(row.hardReset);
    const localhandler = (row) => {
        handleHardReset(row);
        setHardReset(!hardReset);
    }
    return ( 
        <button className={`btn-secondary heavy-refresh-btn ${!hardReset ? 'disable' : ''}`} onClick={() => hardReset ? localhandler(row) : null}>
            Heavy Refresh
        </button>
     );
}
 
export default HeavyRefreshButton;